<template>
    <Title :section="section" />
    <CtaButton :section="section" :form-submit-button="false" :alignment="'push-to-' + boxAlignment"/>
</template>

<script>
    import Title from "@/scripts/view/portfolio/sections/modules/Title.vue";
    import CtaButton from "@/scripts/view/portfolio/sections/_helper/CtaButton.vue";

    export default {
        name: "CtaTitle",
        components: {CtaButton, Title},
        props: ['section'],
        computed: {
            boxAlignment() {
                return this.section.styleSettings?.boxAlign
                    ? this.section.styleSettings.boxAlign.split('-')[0]
                    : "center"
            }
        }
    }
</script>